export default __webpack_public_path__ + "static/9-ways-to-survive-a-european-winter-train-0b2637e09f90ee925db51c38d1072436.jpg";